import { getIsMobile } from "../helpers/getIsMobile";
import { elementItems } from "./vars";

const servObj = (window.servObj = {});

servObj.onHover3D = [];
servObj.onClick3D = [];
servObj.onSoundChange = [];
servObj.isRedactorMode = false;
servObj.isEditMode = false;

servObj.redactorModeObject = null;

servObj.rememberedPosition = null;
servObj.modals = {
    isOpen: false,
    id: null,
    onConfirm: null,
    onCancel: null,
};

// Столы
servObj.allTableBazovii = [];
servObj.allTableSpr = [];
servObj.allTableKomfort = [];
servObj.allTableSpb = [];
servObj.allTableOstrov = [];
servObj.allTableVerstak = [];
servObj.allTableUpakovochnii = [];
servObj.allTableKSM = [];
servObj.allRaskroinii = [];
servObj.allTableSMK = [];
servObj.allTableSSU = [];

// Стойки
servObj.allStoyka = [];

// Столы подкатные
servObj.allStoliPodkatnie = [];

// Тумбы
servObj.allTumbi = [];

// Стеллажи
servObj.allStellazhi = [];

// Стулья
servObj.allStulya = [];

// Верстаки
servObj.allVerstaki = [];

// Элементы
servObj.allTableCover = [];
servObj.allTableStops = [];
servObj.allCornerTable = [];
servObj.allShelfDownSide = [];
servObj.allTableAnnex = [];
servObj.allTumbaLeft = [];
servObj.allTumbaRight = [];
// servObj.allTableInRoom = [];
servObj.allPodstavkaPodSistemniiBlok = [];
servObj.allKeyShelf = [];
servObj.allLotokDlyaProvodov = [];
servObj.allPodstavkaPodNogi = [];
servObj.allKomplektStoek = [];
servObj.allPolkaDlyaKantselyarskikhPrinadlezhnostei = [];
servObj.allPolkaVidvizhnayaPodOrgtekhniku = [];
servObj.allPolkaDlyaKlaviaturi = [];
servObj.allKonteinerDlyaRabochikhOtkhodov = [];
servObj.allPolkaPribornaya = [];
servObj.allOsveshchenieVerkhnee = [];
servObj.allOsveshcheniePodPribornuyu = [];
servObj.allOsveshchenieBokovoe = [];
servObj.allPerfopanel = [];
servObj.allPanelElektromontazhnaya = [];
servObj.allLotokMetallicheskii = [];
servObj.allPlankaDlyaLotkov = [];
servObj.allPolkaKorotkaya = [];
servObj.allPolkaNaklonnaya = [];
servObj.allRamaRazdelitelnaya = [];
servObj.allDerzhatelMonitora = [];
servObj.allElektropanel = [];
servObj.allPolkaDlyaKlaviaturiIMishi = [];
servObj.allKronshteinDlyaPrintera = [];
servObj.allPodstavkaDlyaChertezhei = [];
servObj.allInstrumentalnayaPlanka = [];
servObj.allYashchikMKPlastik = [];
servObj.allYashchikMKMetall = [];
servObj.allDerzhatelRulonaNizhnii = [];
servObj.allDerzhatelRulonaVerkhnii = [];
servObj.allFiksatorRulonnikhMaterialov = [];
servObj.allDerzhatelRulonaBokovoi = [];
servObj.allRezakRulonnikhMaterialov = [];

// ЭЛЕМЕНТЫ СТОЕК
servObj.allElektropanelStoyka = [];
servObj.allDerzhatelRulonaStoyka = [];
servObj.allTumbaStoyka = [];
servObj.allPolkaDlyaKlaviaturiStoyka = [];
servObj.allDopPolkaStoyka = [];

// ЭЛЕМЕНТЫ СТОЛОВ ПОДКАТНЫХ
servObj.allElektropanelSP = [];
servObj.activeElektropanelSP = [];

servObj.allTumbaSP = [];
servObj.activeTumbaSP = [];
servObj.allRuchkaSP = [];
servObj.activeRuchkaSP = [];

// ЭЛЕМЕНТЫ ТУМБ
servObj.allKrishkaTumbi = [];
servObj.activeKrishkaTumbi = [];

servObj.allPodstavkaPMT = [];
servObj.activePodstavkaPMT = [];

// ЭЛЕМЕНТЫ СТЕЛЛАЖЕЙ
servObj.allPolkaStellazh = [];
servObj.activePolkaStellazh = [];
//шкап
servObj.allPolkaWardrobe = [];
servObj.activePolkaWardrobe = [];

servObj.allVerstakStoleshnitsa = [];
servObj.allVerstakTumbaLeft = [];
servObj.allVerstakTumbaRight = [];
servObj.allVerstakNozhkiLeft = [];
servObj.allVerstakNozhkiRight = [];
servObj.allVerstakPerekladini = [];

servObj.allPolkaPribornayaKSM = [];
servObj.allPerfopanelKSM = [];

servObj.activeHitbox = [];
servObj.allHitbox = [];

servObj.activeTableCover = [];
servObj.activeTableStops = [];
servObj.activeCornerTable = [];
servObj.activeShelfDownSide = [];
servObj.activeTableAnnex = [];
servObj.activeTumbaLeft = [];
servObj.activeTumbaRight = [];
servObj.activePodstavkaPodSistemniiBlok = [];
servObj.activeKeyShelf = [];
servObj.activeLotokDlyaProvodov = [];
servObj.activePodstavkaPodNogi = [];
servObj.activeKomplektStoek = [];
servObj.activePolkaDlyaKantselyarskikhPrinadlezhnostei = [];
servObj.activePolkaVidvizhnayaPodOrgtekhniku = [];
servObj.activePolkaDlyaKlaviaturi = [];
servObj.activeKonteinerDlyaRabochikhOtkhodov = [];
servObj.activePolkaPribornaya = [];
servObj.activeOsveshchenieVerkhnee = [];
servObj.activeOsveshcheniePodPribornuyu = [];
servObj.activeOsveshchenieBokovoe = [];
servObj.activePerfopanel = [];
servObj.activePanelElektromontazhnaya = [];
servObj.activeLotokMetallicheskii = [];
servObj.activePlankaDlyaLotkov = [];
servObj.activePolkaKorotkaya = [];
servObj.activePolkaNaklonnaya = [];
servObj.activeRamaRazdelitelnaya = [];
servObj.activeDerzhatelMonitora = [];
servObj.activeElektropanel = [];
servObj.activePolkaDlyaKlaviaturiIMishi = [];
servObj.activeKronshteinDlyaPrintera = [];
servObj.activePodstavkaDlyaChertezhei = [];
servObj.activeInstrumentalnayaPlanka = [];
servObj.activeYashchikMKPlastik = [];
servObj.activeYashchikMKMetall = [];
servObj.activeDerzhatelRulonaNizhnii = [];
servObj.activeDerzhatelRulonaVerkhnii = [];
servObj.activeFiksatorRulonnikhMaterialov = [];
servObj.activeDerzhatelRulonaBokovoi = [];
servObj.activeRezakRulonnikhMaterialov = [];

// ЭЛЕМЕНТЫ СТОЕК
servObj.activeElektropanelStoyka = [];
servObj.activeDerzhatelRulonaStoyka = [];
servObj.activeTumbaStoyka = [];
servObj.activePolkaDlyaKlaviaturiStoyka = [];
servObj.activeDopPolkaStoyka = [];

servObj.activePolkaPribornayaKSM = [];
servObj.activePerfopanelKSM = [];

servObj.activeVerstakStoleshnitsa = [];
servObj.activeVerstakTumbaLeft = [];
servObj.activeVerstakTumbaRight = [];
servObj.activeVerstakNozhkiLeft = [];
servObj.activeVerstakNozhkiRight = [];
servObj.activeVerstakPerekladini = [];

servObj.isShowSizes = false;
servObj.is2dView = false;

// ЭЛЕМЕНТЫ ТЕЛЕЖКИ
servObj.allPolkaTelezhka = [];
servObj.activePolkaTelezhka = [];
servObj.allElektropanelTelezhka = [];
servObj.activeElektropanelTelezhka = [];

servObj.tableColor = {
    changeable_painted_metal_material: { current: "#cbd0cc", default: "#cbd0cc" },
    changeable_kromka_material: { current: "#868684", default: "#868684" },
};

servObj.tableSize = {
    tableWidth: { current: 1200, default: 1200 },
    tableDepth: { current: 700, default: 700 },
    tableHeight: { current: null, default: null },
};

servObj.roomSize = {
    width: 5000,
    length: 8000,
    height: 2600,
};

servObj.lastValueOsveshchenieVerkhnee = "pryamoi";

servObj.colorTheme = "light";

servObj.tempName = "bazovii__osnovanie";

servObj.targetPageKey = "tables";

let sound = false;
Object.defineProperty(servObj, "sound", {
    set: function (newValue) {
        sound = newValue;
        servObj.onSoundChange.forEach((callback) => callback(sound));
    },
    get: function () {
        return sound;
    },
});

servObj.aoTextureCache = {
    names: new Set(), // уникальные имена AO-файлов
    textures: null, // массив загруженных текстур
    map: {}, // имя → THREE.Texture
    loaded: false, // флаг, что загрузка уже выполнена
};

servObj.calcObserver = null;

servObj.calc = elementItems;
servObj.firstPdfPageData = {
    tables: null,
    stoyki_podkatnie: null,
    stoli_podkatnie: null,
};
servObj.counterDsp = 1;
servObj.counterMetall = 1;
servObj.counterDerzhatel = 1;

// Кэш
servObj.cache = {
    lastSavedHash: null, // Хэш последнего сохранённого объекта
    lastGeneratedLink: null, // Последняя сгенерированная ссылка
};

servObj.isMobile = getIsMobile();
